import React from 'react';

interface NavigationButtonsProps {
  currentStep: number;
  totalSteps: number;
  onPrevious: () => void;
  onNext: () => void;
  isSubmitting?: boolean;
}

export default function NavigationButtons({ 
  currentStep, 
  totalSteps, 
  onPrevious, 
  onNext,
  isSubmitting 
}: NavigationButtonsProps) {
  return (
    <div className="flex justify-between pt-6">
      {currentStep > 1 && (
        <button
          type="button"
          onClick={onPrevious}
          className="px-6 py-2 border border-gray-300 rounded-lg text-gray-700 hover:bg-gray-50 transition-all duration-300"
        >
          Précédent
        </button>
      )}
      {currentStep < totalSteps ? (
        <button
          type="button"
          onClick={onNext}
          className="ml-auto px-6 py-2 text-white rounded-lg transition-all duration-300 hover:scale-105 bg-gradient-to-r from-[#2A4365] via-[#4A5568] to-[#C4A052] hover:from-[#1A3355] hover:via-[#3A4558] hover:to-[#B49042]"
        >
          Suivant
        </button>
      ) : (
        <button
          type="submit"
          disabled={isSubmitting}
          className="ml-auto px-6 py-2 text-white rounded-lg transition-all duration-300 hover:scale-105 bg-gradient-to-r from-[#2A4365] via-[#4A5568] to-[#C4A052] hover:from-[#1A3355] hover:via-[#3A4558] hover:to-[#B49042]"
        >
          Obtenir l'estimation
        </button>
      )}
    </div>
  );
}